require.register("app/component/Navbar", function(exports, require, module){
  $0
  
});

